export const MQ_FEATURE = /\(([^)]+)\)/g;
export const MQ_RESOLUTION = /(min-width|max-width|min-height|max-height)/;
export const MQ_RESOLUTION_VALUE = /\d+/g;
export const MQ_RESOLUTION_UNIT = /(em|rem|px|cm|mm|pt|pc)/;
export const FEATURE_PROP_PATTERNS = {
    resolution: MQ_RESOLUTION,
    resolutionUnit: MQ_RESOLUTION_UNIT,
    resolutionValue: MQ_RESOLUTION_VALUE,
};
